/**
 * Lightweight pub/sub for auth lifecycle events.
 * Allows the tRPC transport layer (module-scoped) to signal the React
 * AuthProvider when the server rejects a token.
 */

type Listener = () => void;

const listeners = new Set<Listener>();
let debounceTimer: ReturnType<typeof setTimeout> | null = null;

/** Register a callback that fires when the server returns 401. Returns an unsubscribe fn. */
export function onUnauthorized(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * Notify all listeners that the current token was rejected.
 * Debounced so multiple concurrent 401s don't trigger multiple logouts.
 */
export function emitUnauthorized(): void {
  if (debounceTimer) return;
  debounceTimer = setTimeout(() => {
    debounceTimer = null;
  }, 1_000);
  for (const listener of listeners) listener();
}
